module.exports = __webpack_public_path__ + "img/zain_logo.8677e246.png";